import { Locale } from 'modules/i18n';

export const networkUsageTranslation = {
  [Locale.en]: {
    title: 'Network usage',
  },
};
